import React, { useCallback, useState } from 'react'
import { HomeFilled, ScheduleFilled } from '@ant-design/icons';
import { Tabs } from 'antd';
import SetBatch from './components/SetBatch';
import ProvinceSet from './components/ProvinceSet'
import CountySet from './components/CountySet';
const { TabPane } = Tabs;

function Index() {
  const [key, setKey] = useState('1')
  const [proId, setProId] = useState('')
  const click = useCallback((e: any)=>{
    setKey(e)  
  },[])
  const setPro = useCallback((e: any)=>{
    setProId(e)  
    console.log(123);    
  },[])
  
  return (
    <div style={{padding: '15px', background: '#fff',}} >
      <Tabs defaultActiveKey="1" activeKey={key} onChange={click}>
        <TabPane tab={ <span><HomeFilled />批次设置</span> } key="1" ><SetBatch setKey={click}/></TabPane>

        <TabPane tab={ <span><ScheduleFilled />按省设置</span> }  key="2" ><ProvinceSet setKey={click} setProId={setPro}/></TabPane>
        
        <TabPane tab={ <span><ScheduleFilled/>按县医院设置</span> } key="3" ><CountySet proId={proId}/></TabPane>
      </Tabs>
      {/* <button onClick={click}>123</button> */}
    </div>
  )
}

export default Index